import store from "../index.js";
import api from "../../utils/api";
import { INSURANCE_CANCEL_TYPE } from "../../enum/insurance";

export const modules = {
  store,
};

export const state = {
  _list: {
    items: [],
    total_count: 0,
    total_page: 0,
  },
  _detail: {
    kcbResultList: [],
    officialResultList: [],
    ownerHousePropertyList: [],
    typhoonAnalyzeRequest: {},
    report: {},
  },
  _excels: [],
};

export const mutations = {
  setList(state, item) {
    state._list = {
      items: [],
      total_count: 0,
      total_page: 0,
    };
    state._list = item;
  },
  setExcels(state, item) {
    state._excels = [];
    state._excels = item.items;
  },
  setDetail(state, item) {
    state._detail = {};
    state._detail = item;
  },
};

export const actions = {
  async acTyphoonExcelFields({ commit }, excelFile) {
    const url = "/api/v1/typhoon-excel/fields";
    try {
      const res = await api.post(url, { file: excelFile });
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acTyphoonAnalyzeRequest({ commit }, payload) {
    const url = "/api/v1/typhoon-analyze";
    try {
      const res = await api.post(url, payload);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acTyphoonReportList({ commit }, payload) {
    const params = new URLSearchParams(payload).toString();
    try {
      const res = await api.get(`/api/v1/typhoon-report?${params}`);
      commit("setList", res.data.data);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acTyphoonReportDetail({ commit }, request_seq) {
    const url = `/api/v1/typhoon-report/detail/${request_seq}`;
    try {
      const res = await api.get(url);
      commit("setDetail", res.data.data);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acIndividualCreditSendGuest({ commit }, payload) {
    const url = "/api/v1/typhoon-analyze/individual-credit/guest";
    try {
      const res = await api.post(url, payload);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
